/* istanbul ignore file reason: TODO: tests skipped due to release */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export enum VideoStatus {
  inProgress = 'inProgress',
  finished = 'finished',
  maximum = 'maximum',
}
@Injectable({
  providedIn: 'root',
})
export class TimerService {
  stream$: Subject<VideoStatus> = new Subject<VideoStatus>();
  passedTime;
  runTimer;
  hasStarted;
  hasFinished;
  displayTime;
  maxDisplayTime;
  maximumConstant;
  videoLimit;

  initTimer(timeInSeconds: number, maximum: number) {
    this.passedTime = 0;
    this.maximumConstant = maximum;
    this.videoLimit = timeInSeconds;
    this.runTimer = false;
    this.hasStarted = false;
    this.hasFinished = false;
    this.displayTime = this.getSecondsAsDigitalClock(this.passedTime);
    this.maxDisplayTime = this.getSecondsAsDigitalClock(this.videoLimit);
  }

  startTimer() {
    this.runTimer = true;
    this.hasStarted = true;
    this.timerTick();
  }

  pauseTimer() {
    this.runTimer = false;
  }

  resumeTimer() {
    this.startTimer();
  }

  timerTick() {
    setTimeout(async () => {
      if (!this.runTimer) {
        return;
      }
      this.passedTime++;
      this.displayTime = this.getSecondsAsDigitalClock(this.passedTime);
      if (this.passedTime >= this.maximumConstant) {
        this.hasFinished = true;
        this.stream$.next(VideoStatus.maximum);
      } else if (this.passedTime < this.videoLimit) {
        this.timerTick();
      } else {
        if (!this.hasFinished) {
          this.hasFinished = true;
          this.stream$.next(VideoStatus.finished);
        }
        this.timerTick();
      }
    }, 1000);
  }

  getSecondsAsDigitalClock(inputSeconds: number): string {
    const secNum = parseInt(inputSeconds.toString(), 10);
    const hours = Math.floor(secNum / 3600);
    const minutes = Math.floor((secNum - hours * 3600) / 60);
    const seconds = secNum - hours * 3600 - minutes * 60;
    const minutesString = minutes < 10 ? '0' + minutes : minutes.toString();
    const secondsString = seconds < 10 ? '0' + seconds : seconds.toString();
    return minutesString + ':' + secondsString;
  }
}
